import { Box, SxProps, Typography } from '@mui/material';
import { ProductHelper } from 'helpers/ProductHelper';
import { useEffect, useState } from 'react';
import { colors } from 'styles/theme/colors';
import { deprecatedColors } from 'styles/theme/deprecatedColors';
import { Product, ProductChoice } from '../../../generated/graphql';
import { ListCarousel } from '../../ListCarousel/ListCarousel';

type VariantsProps = {
    product: Product;
    selectedProductId?: number;
    onSelect: (id: number) => void;
    listWrapperStyle?: Omit<SxProps, 'gap'>;
};

const styles = {
    selected: {
        outline: `1px solid ${colors.gray2}`,
        outlineOffset: 2,
    },
} as const;

export function Variants(props: VariantsProps) {
    const {
        product,
        selectedProductId,
        listWrapperStyle,
        onSelect,
    } = props;

    const [selectedVariantId, setSelectedVariantId] = useState<number | undefined>(selectedProductId);

    useEffect(() => {
        setSelectedVariantId(selectedProductId);
    }, [selectedProductId]);

    const choices = ProductHelper.getChoices(product);

    const selectItem = (item: ProductChoice) => {
        setSelectedVariantId(item.product.id);
        onSelect?.(item.product.id);
    };

    return (
        <ListCarousel
            // TODO: Implement gradient if MK-1533 is greenlit.
            // listWrapperStyle={{
            //     WebkitMaskImage: 'linear-gradient(to left, transparent 0%, white 15%)',
            //     maskImage: 'linear-gradient(to left, transparent 0%, white 15%)',
            // }}
            listWrapperStyle={listWrapperStyle}
            listStyle={{ marginTop: 3 }}
            items={choices.map((item) => (
                <Box
                    sx={{
                        width: 90,
                        height: 69,
                        marginBlock: 2,
                        cursor: 'pointer',
                    }}
                    onClick={() => selectItem(item)}
                >
                    <Box
                        title={item?.label ?? ''}
                        sx={{
                            borderRadius: '50%',
                            margin: '0 auto',
                            padding: '8px',
                            overflow: 'hidden',
                            transition: 'outline 0.2s ease-in-out',
                            width: 42,
                            height: 42,
                            ...(item.product.id === selectedVariantId ? styles.selected : {}),
                            backgroundColor: item?.color ?? deprecatedColors.transparent.white50,
                        }}
                    />
                    <Typography
                        variant="body2"
                        fontSize={12}
                        fontWeight={300}
                        textTransform="uppercase"
                        marginTop={0.5}
                        textAlign="center"
                        noWrap
                    >
                        {item?.label ?? ''}
                    </Typography>
                </Box>
            ))}
        />
    );
}
